var app = angular.module("leonardo");

var AttachmentUploadDialog = function($scope, $window, $q, ngDialog, AttachmentService, AuthDataService,
                                      NotificationService, ConfigThemeService) {
  $scope.attachments = $scope.ngDialogData.attachments ? $scope.ngDialogData.attachments : [];
  $scope.task = $scope.ngDialogData.task ? $scope.ngDialogData.task : null;
  $scope.mode = $scope.ngDialogData.mode;
  $scope.showManagement = $scope.ngDialogData.showManagement;
  $scope.account = $scope.ngDialogData.account;

  $scope.initAttachments = function() {
    if ($scope.task)
      angular.forEach($scope.task.attachments, function(value){
        value['progress'] = 0;
        value['finished'] = true;
        value['entity'] = value;
        $scope.attachments.push(value);
      });
    else
      angular.forEach($scope.attachments, function(value){
        value['progress'] = 0;
        value['finished'] = true;
        value['entity'] = value;
      });
  };

  $scope.onAdd = function(attachment) {
    attachment['progress'] = 0;
    if (attachment['document_folder'] || attachment['document_file'] || ($scope.mode === 'upload_note')) {
      attachment['finished'] = true;
    }
    else {
      attachment['finished'] = false;
      attachment.promise.then(function(response) {
        attachment['finished'] = true;
        attachment['entity'] = response.data;
      }, function (error) {
        NotificationService.error(error);
      }, function(evt) {
        attachment['progress'] = parseInt(evt.loaded / evt.total);
      });
    }
    $scope.attachments.push(attachment);
  };

  $scope.cancel = function(attachment, $index) {
    attachment.promise.abort();
    $scope.remove($index);
  };

  $scope.remove = function($index) {
    $scope.attachments.splice($index, 1);
  };

  $scope.showAttachment = function(attachment) {
    if (attachment.document_file) {
      // Use signed_view_url for secure inline viewing
      $window.open(attachment.document_file.signed_view_url || attachment.document_file.secure_share_url);
    }
    else if (attachment.link) {
      $window.open(attachment.link);
    }
    else {
      if (angular.isObject(attachment.file)) {
        var reader  = new FileReader();
        reader.addEventListener("load", function () {
          ngDialog.open({
            template: 'views/templates/dialog/show-image.html',
            className: 'ngdialog-theme-default ngdialog-attachments-view',
            data: {
              name: attachment.name,
              src: reader.result
            }
          });
        }, false);
        reader.readAsDataURL(attachment.file);
      }
      else {
        // Use signed_view_url for secure inline viewing
        $window.open(attachment.signed_view_url || attachment.secure_share_url || attachment.file);
      }
    }
  };

  $scope.getNameAccount = function (account) {
    var array_account = [];
    if (account)
      array_account = angular.isArray(account) ? account : account.split(',');
    var labels = [];
    angular.forEach(array_account, function (account_id) {
      if (AuthDataService.authData.account) {
        angular.forEach(AuthDataService.authData.account.managed_to_me, function (managed) {
          if (managed.id == account_id) {
            labels.push(managed.name);
          }
        });
      }
    });
    return labels.join(',');
  };

  $scope.submit = function() {
    if ($scope.mode === 'upload_note'){
      $scope.confirm($scope.attachments);
    }
    else {
      var ids = [];
      var promises = [];
      angular.forEach($scope.attachments, function(attachment) {
        if (!attachment.entity && (attachment.document_folder || attachment.document_file)) {
          promises.push(
            AttachmentService.linkTo(attachment).then(function(response){
              ids.push(response.data.id);
              attachment.entity = response.data;
            })
          );
        }
        else if (attachment.finished) {
          ids.push(attachment.entity.id);
        }
      });
      $q.all(promises).then(function(){
        if (ids.length === 0) {
          return;
        }
        var attachments = [];
        angular.forEach($scope.attachments, function(attachment) {
          if (attachment.finished) {
            attachment.entity.managed_by = attachment.managed_by;
            attachments.push(attachment.entity);
          }
        });
        $scope.confirm(attachments);
      });
    }
  };

  $scope.getOptions = function() {
    return {color: ConfigThemeService.config.theme_config.successColor};
  };

  $scope.initAttachments();
};

app.controller('AttachmentUploadDialog', ['$scope', '$window', '$q', 'ngDialog', 'AttachmentService', 'AuthDataService',
  'NotificationService', 'ConfigThemeService', AttachmentUploadDialog]);
